import React from 'react';
import {Card} from 'antd';

export const SidebarCard = ({children, title, bordered = true}) => {
  return (
    <Card
      style={{margin: '8px'}}
      styles={{
        body: {
          padding: 0,
        },
        header: {
          fontSize: '11px',
        },
      }}
      variant="borderless"
      title={title}
    >
      {children}
    </Card>
  );
};
